import { memo, useEffect, useState } from 'react';
import { escape } from 'lodash-es';
import {
  FloatingPortal,
  flip,
  offset,
  shift,
  useFloating,
} from '@floating-ui/react';
import { useClickAway } from 'ahooks';
import {
  EditOutlined,
  DisconnectOutlined,
  PaperClipOutlined,
} from '@ant-design/icons';
import { useStore } from '../../store';
import { useLink } from './hooks';
import cn from '@/utils/classnames';
// import Button from '@/app/components/base/button'
import { Button } from 'antd';

type LinkEditorComponentProps = {
  containerElement: HTMLDivElement | null;
};
const LinkEditorComponent = ({
  containerElement,
}: LinkEditorComponentProps) => {
  const { handleSaveLink, handleUnlink } = useLink();
  const selectedLinkUrl = useStore((s) => s.selectedLinkUrl);
  const linkAnchorElement = useStore((s) => s.linkAnchorElement);
  const linkOperatorShow = useStore((s) => s.linkOperatorShow);
  const setLinkAnchorElement = useStore((s) => s.setLinkAnchorElement);
  const setLinkOperatorShow = useStore((s) => s.setLinkOperatorShow);
  const [url, setUrl] = useState(selectedLinkUrl);
  const { refs, floatingStyles, elements } = useFloating({
    placement: 'top',
    middleware: [offset(4), shift(), flip()],
  });

  useClickAway(() => {
    setLinkAnchorElement();
  }, linkAnchorElement);

  useEffect(() => {
    setUrl(selectedLinkUrl);
  }, [selectedLinkUrl]);

  useEffect(() => {
    if (linkAnchorElement) refs.setReference(linkAnchorElement);
  }, [linkAnchorElement, refs]);

  return (
    <>
      {elements.reference && (
        <FloatingPortal root={containerElement}>
          <div
            className={cn(
              'nodrag nopan z-10 inline-flex w-max items-center rounded-md border-[0.5px] border-components-actionbar-border bg-components-actionbar-bg',
              !linkOperatorShow && 'p-1 shadow-md',
              linkOperatorShow &&
                'system-xs-medium p-0.5 text-text-tertiary shadow-sm',
            )}
            style={floatingStyles}
            ref={refs.setFloating}
          >
            {!linkOperatorShow && (
              <>
                <input
                  className="mr-0.5 h-6 w-[196px] appearance-none rounded-sm bg-transparent p-1 text-[13px] text-components-input-text-filled outline-none"
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                  placeholder={'输入链接...'}
                  autoFocus
                />
                <Button
                  type="primary"
                  size="small"
                  disabled={!url}
                  onClick={() => handleSaveLink(url)}
                >
                  好的
                </Button>
              </>
            )}
            {linkOperatorShow && (
              <>
                <a
                  className="flex h-6 items-center rounded-md px-2 hover:bg-state-base-hover"
                  href={escape(url)}
                  target="_blank"
                  rel="noreferrer"
                >
                  <PaperClipOutlined className="mr-1 h-3 w-3" />
                  <div className="mr-1">打开</div>
                  <div
                    title={escape(url)}
                    className="max-w-[140px] truncate text-text-accent"
                  >
                    {escape(url)}
                  </div>
                </a>
                <div className="mx-1 h-3.5 w-[1px] bg-divider-regular"></div>
                <div
                  className="mr-0.5 flex h-6 cursor-pointer items-center rounded-md px-2 hover:bg-state-base-hover"
                  onClick={(e) => {
                    e.stopPropagation();
                    setLinkOperatorShow(false);
                  }}
                >
                  <EditOutlined className="mr-1 h-3 w-3" />
                  编辑
                </div>
                <div
                  className="flex h-6 cursor-pointer items-center rounded-md px-2 hover:bg-state-base-hover"
                  onClick={handleUnlink}
                >
                  <DisconnectOutlined className="mr-1 h-3 w-3" />
                  取消链接
                </div>
              </>
            )}
          </div>
        </FloatingPortal>
      )}
    </>
  );
};

export default memo(LinkEditorComponent);
